import { VFC } from 'react'
import { Article } from 'src/models/Article'
import { fontWeightBold, fontWeightRegular } from 'src/styles/font'
import { membersArticlePage } from 'src/utils/routes'
import styled from 'styled-components'
import { Layout, PopUpButtonLink } from './styles'

export const LatestArticle: VFC<{ article: Article }> = ({ article }) => (
  <Layout>
    <h2>ONLY STORYからのお知らせ</h2>
    <StyledArticle>
      <h3>{article.title}</h3>
      <p>
        {`${article.content.slice(0, 100)}${
          article.content.length > 100 && '...'
        }`}
      </p>
      <p>{article.createdAt.format('YYYY/MM/DD')}</p>
    </StyledArticle>
    <PopUpButtonLink href={membersArticlePage(article.id)}>
      記事を見る
    </PopUpButtonLink>
  </Layout>
)

const StyledArticle = styled.article`
  > * {
    margin: 10px;
  }
  h3 {
    font-size: 18px;
    font-weight: ${fontWeightBold};
  }
  p {
    font-weight: ${fontWeightRegular};
    text-align: left;
    :last-child {
      text-align: right;
    }
  }
`
